import {
  FIELD as PERSONAL_DETAILS_FIELD,
  Form as PersonalDetailsForm,
} from 'screens/BrokerPortal/screens/Registration/components/PersonalDetailsStep/types';
import { RegisterAccountToExistingFirmPayload } from 'screens/BrokerPortal/screens/Registration/api';

const registerAccountToExistingFirmMapper = (
  firmId: number,
  personalDetailsForm: PersonalDetailsForm,
): RegisterAccountToExistingFirmPayload =>
  ({
    firmId: Number(firmId),
    email: personalDetailsForm[PERSONAL_DETAILS_FIELD.EMAIL],
    firstName: personalDetailsForm[PERSONAL_DETAILS_FIELD.FIRST_NAME],
    phone: personalDetailsForm[PERSONAL_DETAILS_FIELD.CONTACT_NUMBER]?.replace(/\s/g, '') ?? '',
    role: personalDetailsForm[PERSONAL_DETAILS_FIELD.ROLE],
    surname: personalDetailsForm[PERSONAL_DETAILS_FIELD.SURNAME],
    howDidUserHearAboutLivemore: personalDetailsForm[PERSONAL_DETAILS_FIELD.HOW_DID_USER_HEAR_ABOUT_LIVEMORE],
    optionalDetails: personalDetailsForm[PERSONAL_DETAILS_FIELD.OPTIONAL_DETAILS],
  } as RegisterAccountToExistingFirmPayload);

export default registerAccountToExistingFirmMapper;
